import { FormControl, Stack, Box } from '@chakra-ui/react';
import ActionHeaders from '../../edit/ActionHeaders';
import { stackStyling } from 'components/forms/new/formStyles';
import { useTriggerForm } from '../useTriggerForm.js';

const WebhookHeadersSection = ({
    darkMode,
    setCursorPosition,
    updateActionHeaders,
}) => {
    const { headers, setHeaders } = useTriggerForm();

    const handleUpdateHeaders = (newHeaders) => {
        setHeaders(newHeaders);
        if (updateActionHeaders) {
            updateActionHeaders(newHeaders);
        }
    };

    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                sx={{
                    ...stackStyling(true),
                    height: 'auto',
                    marginBottom: '10px',
                }}
                align="flex-start">
                <Box flex={1}>
                    <ActionHeaders
                        setCursorPosition={setCursorPosition}
                        darkMode={darkMode}
                        actionHeaders={headers}
                        updateActionHeaders={handleUpdateHeaders}
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default WebhookHeadersSection;
